import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BankAccount } from '@payments/models/payment-preferences-page-view-model';
import { BankDetailRowComponent } from '../bank-detail-row.component';

@Component({
  selector: 'app-bank-detail-row-desktop',
  templateUrl: './bank-detail-row-desktop.component.html',
  styleUrls: [
    '../bank-detail-row.component.scss',
    './bank-detail-row-desktop.component.scss',
  ],
})
export class BankDetailRowDesktopComponent extends BankDetailRowComponent {}
